// extracted by mini-css-extract-plugin
export default {"container":"CandidateLinks_container__MTP3L","header":"CandidateLinks_header__FlRSB","link-item":"CandidateLinks_link-item__011Ct"};